module.exports = "<div class=\"page\">\n\t<nav>\n\t\t<a routerLink=\"/admin/users\" class=\"button\">Users</a>\n\t</nav>\n\t<router-outlet></router-outlet>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/admin/admin.component.html
// module id = ../../../../../src/app/admin/admin.component.html
// module chunks = main